import { showLegacyIM } from "./LegacyInternetModule";

export default function ListQuotes() {
  showLegacyIM("List Quotes", "/apps/vaadinorderlisting");
}
